import React from 'react';
import { Col, Card, Button, Icon, Input, Tooltip } from 'antd';
import Slider from 'react-slick';
import { convertImage } from '../../../../../services/contents';
import { useTranslation } from 'react-i18next';
import HideWhenCampaignActive from '../../containers/HideWhenCampaignActiveContainer';

const ContentSlider = ({
  listOfContentsInCampaignFiltered,
  groupedDisplays,
  isPaymentStatusApproved,
  editCampaignActive,
  currentCampaign,
  settingsSlider,
  customContents,
  handleContent,
  showModalContent,
  showModalDeleteContentRelation,
  showModalCloneNameContent,
  haveContentInRelation,
  getTooltipAndCompatibility,
  openNotification,
  checkAddInRelation
}) => {
  const { t } = useTranslation();

  return (
    <Col xs={24} sm={24} md={24} lg={24}>
      <div className="slider-container">
        {listOfContentsInCampaignFiltered.length === 0 ? (
          <div id="1" className="contentMessage">
            <p>{t('You must select a content')}</p>
            <Icon type="arrow-up" style={{ fontSize: '15px', marginLeft: '10px' }} />
          </div>
        ) : (
          <Slider {...settingsSlider}>
            {listOfContentsInCampaignFiltered.map((content, index) => (
              <div key={index} style={{ padding: '0 8px' }}>
                <Card className="cardContent">
                  <div style={{ display: 'flex' }}>
                    <Input
                      size="small"
                      className={`${
                        groupedDisplays ? 'inputContentNameGroupedDisplays' : 'inputContentName'
                      }`}
                      placeholder={t('Identify your ad...')}
                      value={content.name}
                      onChange={e => handleContent(e.target.value, content)}
                    />
                    {!groupedDisplays && (
                      <Tooltip
                        title={t('Copy the name of this ad to all ads in the same version.')}
                      >
                        <Icon
                          type="copy"
                          onClick={() => showModalCloneNameContent(content)}
                          style={{ cursor: 'pointer' }}
                          className="copyBadge"
                        />
                      </Tooltip>
                    )}
                  </div>
                  <div className="centerCard versionBadgeContainer">
                    <div className="imageWrapper">
                      <img
                        src={convertImage(content.file_thumb)}
                        onClick={() => showModalContent(content)}
                        className="contentCardImage"
                        alt=""
                      />
                      {(!editCampaignActive ||
                        (editCampaignActive && currentCampaign.status !== 'proposal')) && (
                        <span className="primaryCircle versionBadge">
                          {content.content_version_name || 'V1'}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="contentCardContent">
                    <p className="textCard centerCard">
                      {content.width} x {content.height}
                    </p>
                    <HideWhenCampaignActive contentId={content.id}>
                      {!groupedDisplays && !isPaymentStatusApproved && (
                        <Tooltip title={t('Stop using this ad for the campaign.')}>
                          <Button
                            shape="circle"
                            className="icon-card cardRed"
                            onClick={() => showModalDeleteContentRelation(content)}
                          >
                            <Icon type="close" />
                          </Button>
                        </Tooltip>
                      )}
                      {groupedDisplays && !haveContentInRelation(content) && (
                        <>
                          {(() => {
                            const {
                              hasCompatibleResolution,
                              tooltipText,
                              hasVersion
                            } = getTooltipAndCompatibility(content);
                            return (
                              <Tooltip title={tooltipText}>
                                <Button
                                  shape="circle"
                                  className={
                                    !hasCompatibleResolution || hasVersion
                                      ? 'icon-card cardGray'
                                      : 'icon-card cardGreen'
                                  }
                                  style={{
                                    backgroundColor:
                                      !hasCompatibleResolution || hasVersion ? '#c7bfbf' : '#EBF8F2'
                                  }}
                                  onClick={
                                    !hasCompatibleResolution || hasVersion
                                      ? () => openNotification(hasVersion)
                                      : () => checkAddInRelation(content)
                                  }
                                >
                                  <Icon type="plus" />
                                </Button>
                              </Tooltip>
                            );
                          })()}
                        </>
                      )}
                    </HideWhenCampaignActive>
                  </div>
                </Card>
              </div>
            ))}
          </Slider>
        )}
      </div>
    </Col>
  );
};

export default ContentSlider;
